import { db } from '../firebase';
import {
  collection,
  getDocs,
  addDoc,
  doc,
  deleteDoc,
  updateDoc,
} from 'firebase/firestore';
import { Category } from '../types/categories.types';

// Function to create a new category in Firestore
export async function createCategory(
  name: string,
  description: string,
  isHighSchool: boolean,
  isElementary: boolean
): Promise<Category> {
  const categoryData: Omit<Category, 'id'> = {
    name,
    description,
    isHighSchool,
    isElementary,
  };

  try {
    const docRef = await addDoc(collection(db, 'categories'), categoryData);
    console.log('Category created with ID:', docRef.id);

    return { id: docRef.id, ...categoryData };
  } catch (error) {
    console.error('Error creating category:', error);
    throw new Error('Failed to create category.');
  }
}

// Function to fetch all categories from Firestore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function getCategories(regionId: any): Promise<Category[]> {
  try {
    const querySnapshot = await getDocs(collection(db, 'categories'));
    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...(doc.data() as Omit<Category, 'id'>),
    })) as Category[];
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw new Error('Failed to fetch categories.');
  }
}

export async function updateCategory(
  id: string,
  category: Partial<Category>
): Promise<void> {
  try {
    const categoryRef = doc(db, 'categories', id);
    await updateDoc(categoryRef, category);
  } catch (error) {
    console.error('Error updating category:', error);
    throw new Error('Failed to update category.');
  }
}

// Function to link a category to a project in Firestore
export async function linkCategoryToProject(
  categoryId: string,
  projectId: string
): Promise<void> {
  try {
    const projectRef = doc(db, 'projects', projectId);
    await updateDoc(projectRef, { categoryId });
  } catch (error) {
    throw new Error('Failed to link category to project.');
  }
}

// function to delete cataegory from Firestore
export async function deleteCategory(categoryId: string): Promise<void> {
  try {
    const categoryRef = doc(db, 'categories', categoryId);
    await deleteDoc(categoryRef);
    console.log(`Category with ID ${categoryId} deleted successfully.`);
  } catch (error) {
    console.error('Error deleting category:', error);
    throw new Error('Failed to delete category.');
  }
}
